export const dialogActionButton = {
  display: 'flex',
  justifyContent: 'space-between',
  mb: '1rem',
  mr: { xs: '0.75rem', sm: '1rem' },
  pt: 0,
  alignSelf: { xs: 'none', sm: 'end' },
}

export const dialogCancelButtonMob = {
  display: { xs: 'inline-block', sm: 'none' },
  ml: { xs: '0.75rem' },
}

export const blockDialogCancelBtnDesk = {
  display: { xs: 'none', sm: 'inline-block' },
}

export const dialogIcon = {
  fontSize: '5rem',
}

export const dialogContent = {
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  alignItems: 'center',
  marginTop: 2.5,
  marginBottom: { xs: '0', sm: '0.25rem' },
}

export const dialog = {
  maxWidth: { xs: '16.25rem', sm: '28.625rem' },
}
